import { useCallback, useEffect, useRef, useState } from 'react'
import { __DEV__ } from '../constants'
import { getAudioData } from './get-audio-data'

export const useAudioData = src => {
  if (!src) {
    if (__DEV__) console.warn("useAudioMetadata requires a 'src' parameter")
    return null
  }

  const mountState = useRef({ isMounted: true })

  useEffect(() => {
    const { current } = mountState
    current.isMounted = true
    return () => {
      current.isMounted = false
    }
  }, [])

  const [metadata, setMetadata] = useState(null)

  const fetchMetadata = useCallback(async () => {
    const data = await getAudioData(src)
    if (mountState.current.isMounted) {
      setMetadata(data)
    }
  }, [src])

  useEffect(() => {
    fetchMetadata()
  }, [fetchMetadata])

  return metadata
}
